<template>
    <div>
        <modal id="pending-field-audits-modal">
            <template slot="body">

                <h2 class="font-weight-bolder text-danger">Field Audits!</h2>

                <div class="text-muted mt-2 mb-4">
                    <p>
                        You have a Field Audit due. <br>
                        If you have not already contacted the office, please do so as soon as possible to schedule an inspection on your next project.
                    </p>
                    <p>
                        Call us for any question: (562) 485-9144 Ext 101
                    </p>
                </div>

                <div class="d-flex">
                    <button class="btn btn-default" type="button" @click="closeModal('pending-field-audits-modal')">Close</button>
                    <a href="/field-inspections" class="btn btn-danger ml-auto">Field Audits</a>
                </div>
            </template>
        </modal>
    </div>
</template>
<script>
export default {

    mounted(){
        this.openModal('pending-field-audits-modal')
    }
}
</script>
